import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ListSkeleton = ({ count = 5 }) => {
  return <Skeleton className="w-full h-12" count={count} />;
};

export default ListSkeleton;
